import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterNull'
})
export class FilterNullPipe implements PipeTransform {
  transform(value: any[]): any[] {
    if (!Array.isArray(value)) {
      return value; // Return as-is if it's not an array
    }
    return value.filter(item => item !== null && item !== undefined);
  }
}